import { AgreementContext } from "@sb1finans/components/dist/AgreementContext";
import {Order, VendorsApi, VendorsApiFactory} from "@sb1finans/new-api/dist"
import axios, { Axios } from "axios";
import { createContext, useCallback, useContext, useEffect, useRef, useState } from "react";
import { useAgreementId } from "../hooks";

interface OrderFilter {
    fromDate: Date
    toDate: Date
}

interface OrderContextProps {
    filter: OrderFilter
    isFetching: boolean
    fetchOrders: (filter: OrderFilter) => void
    orders: Order[]
    createOrder: (order: Order) => Promise<string>
}

interface OrderCache {
    [key: string]: Order
}

const emptyContext: OrderContextProps = {
    filter: {
        fromDate: new Date(),
        toDate: new Date()
    },
    isFetching: false,
    fetchOrders: () => {},
    orders: [],
    createOrder: async (order: Order) => { return ""}
}
export const OrderContext = createContext<OrderContextProps>(emptyContext)

interface OrderProviderPros {
    children: React.ReactNode
    vendorsApi: VendorsApi
}

export const OrderProvider: React.FC<OrderProviderPros> = ({children, vendorsApi}) => {
  
    console.log("IN ORDER PROVIDER")
    const currentDate = new Date()
    const fromDate = new Date()
    
    const {agreementId: activeAgreementId} = useAgreementId()

    const [filter, setFilter] = useState<OrderFilter>({fromDate: fromDate, toDate: new Date()})
    const [isFetching, setIsFetching] = useState<boolean>(false)
    const [orderCache, setOrderCache] = useState<OrderCache>({})
    const orderCacheRef = useRef(orderCache)

    /*

<http://sb1finans-api-svc:7000/vendors/11af723a-9df6-0bb2-a4c3-798aa57feb99/orders?fromDate=2022-12-01T00:00:00.000Z&toDate=2022-12-31T00:00:00.000Z&maxCount=10&nextPageToken=eyJmcm9tRGF0ZSI6IjIwMjItMTItMDFUMDA6MDA6MDBaIiwidG9EYXRlIjoiMjAyMi0xMi0zMFQwMDowMDowMFoiLCJsaW1pdCI6MTB9>; rel="next"
    */
    const _fetchOrders = async () => {
        setIsFetching(true)
        let hasNext = true
        let nextPageToken: string | undefined = undefined
        while (hasNext) {
            console.log("Caling get order with token", nextPageToken)
            const response = await vendorsApi.listOrders(activeAgreementId!, filter.fromDate.toISOString(), filter.toDate.toISOString(), undefined, undefined, 10, nextPageToken)
            const orders = response.data
            const newCache = {...orderCache}
            orders.forEach((order: Order) => {
                newCache[order.id] = order
            })
            const links = response.headers.link ? parseLinkHeader(response.headers.link) : {}
            if (links.next) {
                console.log(links.next)
                const token = new URL(links.next).searchParams.get("nextPageToken")
                console.log(token)
                hasNext = token != undefined && token !== null && token != nextPageToken
                nextPageToken = token !== null ? token : undefined
            } else {
                hasNext = false
            }
            setOrderCache(prevState => ({...prevState, ...newCache}))
            //setOrderCache(newCache)
        }
        setIsFetching(false)
    }

    useEffect(() => {
        _fetchOrders()
    }, [filter.fromDate, filter.toDate])

    useEffect(() => {
        setOrderCache({})
        setFilter({fromDate: new Date(currentDate.getFullYear(), currentDate.getMonth() - 1, currentDate.getDay()), toDate: currentDate})
    }, [activeAgreementId])

    const fetchOrders = (newFilter: OrderFilter) => {
        console.log(newFilter.fromDate < filter.fromDate)
        console.log(newFilter.toDate > filter.toDate)
        console.log("Datefilter: ", newFilter.fromDate, newFilter.toDate, filter.fromDate, filter.toDate)
        const retFilter = {
            ...filter,
            fromDate: newFilter.fromDate < filter.fromDate ? newFilter.fromDate : filter.fromDate,
            toDate: newFilter.toDate > filter.toDate ? newFilter.toDate : filter.toDate,
        }
        setFilter(retFilter)
    }

    const createOrder = async (order: Order): Promise<string> => {
        const resp = await vendorsApi.createOrder(activeAgreementId!, order)
        return "Ok!"
    }
    
    const orders = Object.values(orderCache).sort((a, b) => {
        if (a.createdAt && b.createdAt) {
            if (a.createdAt > b.createdAt) {
                return -1
            } else if (a.createdAt < b.createdAt) {
                return 1
            } else {
                return 0
            }
        } else {
            return 0
        }
    })
    console.log("Orders: ", orders)
    return (
        <OrderContext.Provider value={{filter, isFetching, fetchOrders, createOrder, orders: orders }}>
            {children}
        </OrderContext.Provider>
    )
}

interface Links {
    [key: string]: string
}

function parseLinkHeader(header: string): Links {
    if (header.length == 0) {
      throw new Error("input must not be of zero length");
    }
  
    // Split parts by comma
    var parts = header.split(',');
    var links: any = {};

    parts.forEach((p: string) => {
      const section = p.split(';');
      if (section.length != 2) {
        return
      }
      const url = section[0].replace(/<(.*)>/, '$1').trim();
      const name = section[1].replace(/rel="(.*)"/, '$1').trim();
      links[name] = url;
    })
  
    return links;
}

/*
http://api.azure.sb1finans.no/vendors/acbe8201-0590-d40e-c36d-faff4be49699/orders?fromDate=2022-12-01T23:00:00.000Z&toDate=2023-01-03T12:27:05.793Z&maxCount=10&nextPageToken=eyJmcm9tRGF0ZSI6IjIwMjItMTItMDFUMjM6MDA6MDBaIiwidG9EYXRlIjoiMjAyMi0xMi0zMFQwMDowMDowMFoiLCJsaW1pdCI6MTB9>; rel="next"

http://api.azure.sb1finans.no/vendors/acbe8201-0590-d40e-c36d-faff4be49699/orders?fromDate=2022-12-01T23:00:00.000Z&toDate=2023-01-03T12:27:05.793Z&maxCount=10&nextPageToken=eyJmcm9tRGF0ZSI6IjIwMjItMTItMDFUMjM6MDA6MDBaIiwidG9EYXRlIjoiMjAyMi0xMi0zMFQwMDowMDowMFoiLCJsaW1pdCI6MTB9>; rel="next"
*/